var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "forms-container" }, [
            _c(
              "div",
              { staticClass: "row no-margin" },
              [
                _c(
                  "draggable",
                  {
                    attrs: { options: _vm.dragOptions },
                    on: {
                      start: function($event) {
                        _vm.drag = true
                      },
                      change: _vm.onChange
                    },
                    model: {
                      value: _vm.menuArr,
                      callback: function($$v) {
                        _vm.menuArr = $$v
                      },
                      expression: "menuArr"
                    }
                  },
                  _vm._l(_vm.menuArr, function(element, index) {
                    return _c(
                      "div",
                      {
                        key: "menu-" + element.id,
                        staticClass: "edit-menu",
                        attrs: { id: "menu-" + element.id }
                      },
                      [
                        _c("img", {
                          staticClass: "drag-handle",
                          attrs: { src: "/static/images/app-bar-icon.png" }
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(element.menu_title))]),
                        _vm._v(" "),
                        _c("div", { staticClass: "menu-actions" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "javascript:void(0)",
                                id: "edit-menu"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleEditMenu(
                                    "menu-" + element.id,
                                    index
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: { src: "/static/images/edit-icon.png" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "javascript:void(0)",
                                id: "delete-menu"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteMenu(element.id)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: { src: "/static/images/delete-icon.png" }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(" Menu Sequence in Back-end")]),
          _vm._v("\n            " + _vm._s(_vm.menuArr) + "\n            ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "forms-container" }, [
            _c(
              "div",
              { staticClass: "row no-margin" },
              [
                [
                  _c(
                    "swiper",
                    {
                      ref: "mySwiper",
                      staticClass: "sales-programs-menu",
                      attrs: { options: _vm.swiperOptionSubMenu }
                    },
                    [
                      _vm._l(_vm.menuArr, function(menuLoop, index1) {
                        return [
                          _c("swiper-slide", { key: "slide_" + index1 }, [
                            _c("span", {
                              class: "spm-menu " + menuLoop.icon_url
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "Element : " +
                                  _vm._s(index1 + 1) +
                                  " : " +
                                  _vm._s(menuLoop.menu_title)
                              )
                            ])
                          ])
                        ]
                      })
                    ],
                    2
                  )
                ]
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Dragable & Swipe View")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08e031be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e031be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dragable.vue
// module id = null
// module chunks = 